import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

import { useAuthStore } from './store';
import SplashScreen from './pages/SplashScreen';
import HomePage from './pages/HomePage';
import ResultPage from './pages/ResultPage';
import ProjectsPage from './pages/ProjectsPage';
import AuthCallback from './pages/AuthCallback';
import PaymentSuccess from './pages/PaymentSuccess';
import EmailConfirm from './pages/EmailConfirm';
import ResetPassword from './pages/ResetPassword';
import SubscriptionPage from './pages/SubscriptionPage';
import InvoicesPage from './pages/InvoicesPage';
import SharesPage from './pages/SharesPage';
import SendSimulationPage from './pages/SendSimulationPage';
import ShareHistoryPage from './pages/ShareHistoryPage';
import ShareDetailPage from './pages/ShareDetailPage';
import EmailTemplateSettings from './pages/EmailTemplateSettings';
// Router wrapper to handle OAuth callback and email tokens
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  // Check URL fragment for email confirmation
  if (location.hash?.includes('confirm_email=')) {
    return <EmailConfirm />;
  }
  
  // Check URL fragment for password reset
  if (location.hash?.includes('reset_password=')) {
    return <ResetPassword />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<SplashScreen />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/result" element={<ResultPage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<HomePage />} />
      <Route path="/subscription" element={<SubscriptionPage />} />
      <Route path="/invoices" element={<InvoicesPage />} />
      <Route path="/shares" element={<SharesPage />} />
        <Route path="/send-simulation" element={<SendSimulationPage />} />
        <Route path="/share-history" element={<ShareHistoryPage />} />
        <Route path="/share-detail/:shareId" element={<ShareDetailPage />} />
        <Route path="/email-template" element={<EmailTemplateSettings />} />
        <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

// Auth checker component
function AuthChecker({ children }) {
  const { checkAuth } = useAuthStore();
  
  useEffect(() => {
    // Skip if returning from OAuth
    if (window.location.hash?.includes('session_id=')) {
      return;
    }
    checkAuth();
  }, [checkAuth]);
  
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthChecker>
        <div className="h-full w-full bg-background overflow-hidden">
          <AppRouter />
          <Toaster 
            position="bottom-center" 
            toastOptions={{
              style: {
                background: 'rgba(0, 0, 0, 0.85)',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '9999px',
              }
            }}
          />
        </div>
      </AuthChecker>
    </BrowserRouter>
  );
}

export default App;
